import { render, staticRenderFns } from "./DateApproachingInfoIcon.vue?vue&type=template&id=17715434&scoped=true&lang=html&"
import script from "./DateApproachingInfoIcon.vue?vue&type=script&lang=js&"
export * from "./DateApproachingInfoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17715434",
  null
  
)

export default component.exports